export default "__VITE_ASSET__2dedfead__"